export const STAFF_PERMISSIONS = {
  read: 'has_read_access',
  write: 'has_change_access',
};
